module.exports = __webpack_public_path__ + "media/images/site_files/site-ca93e140a15b9ed749b61d125c454768.webmanifest";